module.exports = __webpack_public_path__ + "media/images/pic/courses/benefit04-4eee457dee53d6983ce60e0c514a5451.svg";